<template>
  <div class="expense-summary-grid-view">
    <div class="expense-summary-grid-view__grid">
      <div class="expense-summary-grid-view__header">RFR Expense Summary</div>
      <div class="expense-summary-grid-view__content">
        <div class="expense-summary-grid-view__row">
          <div class="expense-summary-grid-view__label">Mileage:</div>
          <div class="expense-summary-grid-view__value">
            ${{ tripLogStore.mileageAmount }}
          </div>
        </div>
        <div class="expense-summary-grid-view__row">
          <div class="expense-summary-grid-view__label">Airfare:</div>
          <div class="expense-summary-grid-view__value">
            ${{ props.expenseSummary.Airfare }}
          </div>
        </div>
        <div class="expense-summary-grid-view__row">
          <div class="expense-summary-grid-view__label">Car Rental + Gas:</div>
          <div class="expense-summary-grid-view__value">
            ${{
              (
                (props.expenseSummary.CarRental ?? 0) +
                (props.expenseSummary.Gas ?? 0)
              ).toFixed(2)
            }}
          </div>
        </div>
        <div class="expense-summary-grid-view__row">
          <div class="expense-summary-grid-view__label">Tolls:</div>
          <div class="expense-summary-grid-view__value">
            ${{ props.expenseSummary.Tolls }}
          </div>
        </div>
        <div class="expense-summary-grid-view__row">
          <div class="expense-summary-grid-view__label">Parking:</div>
          <div class="expense-summary-grid-view__value">
            ${{ props.expenseSummary.Parking }}
          </div>
        </div>
        <div class="expense-summary-grid-view__row">
          <div class="expense-summary-grid-view__label">
            Transit (taxi, train, bus etc.):
          </div>
          <div class="expense-summary-grid-view__value">
            ${{ props.expenseSummary.Taxi }}
          </div>
        </div>
        <div class="expense-summary-grid-view__row">
          <div class="expense-summary-grid-view__label">Motel:</div>
          <div class="expense-summary-grid-view__value">
            ${{ props.expenseSummary.Motel }}
          </div>
        </div>
        <div class="expense-summary-grid-view__row">
          <div class="expense-summary-grid-view__label">Food:</div>
          <div class="expense-summary-grid-view__value">
            ${{ props.expenseSummary.Food }}
          </div>
        </div>
        <div class="expense-summary-grid-view__row">
          <div class="expense-summary-grid-view__label">Misc:</div>
          <div class="expense-summary-grid-view__value">
            ${{ props.expenseSummary.Misc }}
          </div>
        </div>
        <div class="expense-summary-grid-view__row">
          <div class="expense-summary-grid-view__label total">Total:</div>
          <div class="expense-summary-grid-view__value">
            ${{ tripLogStore.totalBalance }}
          </div>
        </div>
      </div>
    </div>

    <div class="expense-summary-grid-view__grid">
      <div class="expense-summary-grid-view__header">
        Corporate Charges <small>(Expenses Charged to OU)</small>
      </div>
      <div class="expense-summary-grid-view__content">
        <div class="expense-summary-grid-view__row">
          <div class="expense-summary-grid-view__label">Airfare:</div>
          <div class="expense-summary-grid-view__value">
            ${{ props.expenseSummary.OuAir }}
          </div>
        </div>
        <div class="expense-summary-grid-view__row">
          <div class="expense-summary-grid-view__label">Car Rental:</div>
          <div class="expense-summary-grid-view__value">
            ${{ props.expenseSummary.OuCarRental }}
          </div>
        </div>
        <div class="expense-summary-grid-view__row">
          <div class="expense-summary-grid-view__label">Misc:</div>
          <div class="expense-summary-grid-view__value">
            ${{ props.expenseSummary.OuOther }}
          </div>
        </div>
        <div class="expense-summary-grid-view__row">
          <div class="expense-summary-grid-view__label total">
            Total OU Expenses:
          </div>
          <div class="expense-summary-grid-view__value">
            ${{ tripLogStore.totalCorporateCharges }}
          </div>
        </div>
      </div>
    </div>
    <div class="expense-summary-grid-view__total">
      Total Expenses: ${{ tripLogStore.totalExpenses }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TripExpensesSummaryDisplay } from "@/Domain/TripExpensesSummaryDisplay";
import { useTripLogStore } from "@/stores/useTripLogStore";

const tripLogStore = useTripLogStore();

const props = defineProps<{
  expenseSummary: TripExpensesSummaryDisplay;
}>();
</script>

<style scoped lang="scss">
.expense-summary-grid-view {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 1rem;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;

  &__content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  &__row {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 1rem;
    align-items: center;
  }

  &__label {
    color: #555;

    &.total {
      font-weight: bold;
    }
  }

  &__value {
    color: #333;
    text-align: right;

    &.total {
      font-weight: bold;
    }
  }

  &__grid {
    flex: 1 1 100%;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    @include media-breakpoint-up(sm) {
      flex: 1 1 calc(50% - 1rem);
    }
  }

  &__header {
    font-weight: bold;
    color: #333;
    border-bottom: 2px solid #ddd;
    padding-bottom: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    font-size: 0.95rem;
    min-height: 60px;

    small {
      font-size: 0.875rem;
      color: #777;
    }
  }

  &__total {
    font-weight: bold;
    color: #007bff;
    text-align: right;
    border-top: 2px solid #ddd;
    padding-top: 0.5rem;
    margin-top: 1rem;
    width: 100%;
  }
}
</style>
